/* Keeps every corner icon (.hb-icon) fully on screen. Icons are allowed to overhang their card,
   but near the screen edge (phones, tablets) that pushes them off screen: nudge those back inside.
   Loaded by the HortaBerry footer (on every page).
   - Measures what is really on screen: centring, tilt, slides, everything included.
   - Re-measures whenever things move: while scrolling (the hero's cards slide with the scroll),
     when CSS animations finish, and when the usable width changes (e.g. a scrollbar appears).
   - Never pulls an icon further than back onto its own card: even a bad measurement can't
     throw an icon away from its card (the hero's right-hand icons once landed 630px off). */
(() => {
  if (window.__hbIconKeep) return;
  window.__hbIconKeep = true;
  const MARGIN = 4; // px kept between an icon and the screen edge

  function keep() {
    const W = document.documentElement.clientWidth;
    const icons = [...document.querySelectorAll('.hb-icon')];
    // read everything first (one layout), then write
    const plans = icons.map((el) => {
      if (!el.offsetParent && getComputedStyle(el).position !== 'fixed') return null;
      // Still entering (Rólunk cards rise and tilt into place): its geometry isn't final, and a
      // nudge measured now jumped by ~7 px once it settled (18 Oct, phone recording). Measured
      // again when the entrance transition ends.
      if (el.closest('.fe-pending')) return null;
      const r = el.getBoundingClientRect();
      if (!r.width) return null;
      // Far off screen: nothing to keep in view yet (measured again as it comes near).
      if (r.bottom < -innerHeight || r.top > innerHeight * 2) return null;
      const now = parseFloat(el.style.getPropertyValue('--hb-icon-nudge')) || 0;
      const host = (el.closest('.hb-icon-host') || el.parentElement).getBoundingClientRect();
      const left = r.left - now, right = r.right - now; // where it would be without our nudge
      let nudge = 0;
      if (left < MARGIN) nudge = Math.min(MARGIN - left, Math.max(0, host.left - left));        // at most back onto the card
      else if (right > W - MARGIN) nudge = -Math.min(right - (W - MARGIN), Math.max(0, right - host.right));
      return [el, Math.round(nudge)];
    });
    plans.forEach((p) => {
      if (!p) return;
      const [el, n] = p;
      // Write only when it changes: a style write on every scroll frame restyles every icon.
      const was = el.style.getPropertyValue('--hb-icon-nudge');
      if (n) { if (was !== n + 'px') el.style.setProperty('--hb-icon-nudge', n + 'px'); }
      else if (was) el.style.removeProperty('--hb-icon-nudge');
    });
  }

  let raf = 0, t;
  const frame = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; keep(); }); };
  const later = () => { clearTimeout(t); t = setTimeout(keep, 150); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', keep); else keep();
  window.addEventListener('load', keep);
  window.addEventListener('resize', later);
  window.addEventListener('scroll', frame, { passive: true, capture: true }); // the hero's slides follow the scroll
  if (window.ResizeObserver) new ResizeObserver(later).observe(document.documentElement); // usable width (scrollbar)
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(keep);
  document.addEventListener('transitionend', later, true); // entrance animations settle the tilt
  document.addEventListener('animationend', later, true);
  document.addEventListener('shopify:section:load', later);
  document.addEventListener('shopify:block:select', later);
})();
